import * as React from "react"
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md"
import { wrap, increment, decrement, input } from "./numeric-input.module.css"
export function NumericInput({
  onIncrement,
  onDecrement,
  className,
  disabled,
  position,
  ...props
}) {
  console.log(position)
  return (
    <div className={wrap}      style={{position:{position}}}>
      <input
        disabled={disabled}
        type="numeric"
        className={[input, className].join(" ")}
        {...props}
      />
      <button
        disabled={disabled}
        className={increment}
        aria-label="Increment"
        onClick={onIncrement}
      >
        <span>+</span>
        <MdArrowDropUp style={{width:'30px',height:'30px'}} />
      </button>
      <button
        disabled={disabled}
        className={decrement}
        aria-label="Decrement"
        onClick={onDecrement}
      >
        <span>-</span>
        <MdArrowDropDown style={{width:'30px',height:'30px'}} />
      </button>
    </div>
  )
}